import React, { useState, useContext, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { AppContext } from '../../App';
import { isUserAuthenticated, isUserInRoles } from '../Shared/UserIdentity';
import { MobileViewContext } from './Viewpoint';
import "./Collapse.css";
import Collapse from "@kunukn/react-collapse";

export const NavMenu = () => {
    const context = useContext(AppContext);
    const contextMobileView = useContext(MobileViewContext);

    const mobileMenuRef = useRef();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [ariaExpanded, setAriaExpanded] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                contextMobileView.updateMobileView(entry.isIntersecting);
            }, { rootMargin: '0px' }
        );

        mobileMenuRef.current && observer.observe(mobileMenuRef.current);

        return () => observer.unobserve(mobileMenuRef.current);
    }, []);

    const toggleMenu = (e) => {
        if (contextMobileView.isMobileView) {
            setMobileMenuOpen(!mobileMenuOpen);
            setAriaExpanded(!ariaExpanded);
        }
    }

    const toggleOpenIndex = (e) => {
        e.stopPropagation();
        toggleMenu(e);
    }

    const handleMobileMenuClick = (e) => {
        toggleMenu(e);
    }

    const handleMobileMenuKeyDown = (e) => {
        if (e.key == "Enter" || e.keyCode == 32) {
            e.preventDefault();
            toggleMenu(e);
        }
        e.stopPropagation();
    }

    const MenuItem = (props) => {
        if (props.roles) {
            if (props.roles == '*') {
                if (!isUserAuthenticated(context)) return <></>;  //Hide if user not login
            } else if (props.roles == '!*') {
                if (isUserAuthenticated(context)) return <></>;   //Hide if user login
            }
            else if (!isUserInRoles(props.roles, context)) {      //Hide if user not in roles
                return <></>;
            }
        }
        return (
            <li value={props.value} >
                <NavLink to={props.path}
                    onClick={toggleOpenIndex}
                >{props.name}</NavLink>
                {props.children}
            </li>
        );
    }

    const MenuList = () => {
        return (<ul>
            <MenuItem roles={'Admin'} path="/ErrorsQueue" name="Errors Queue" />
            <MenuItem roles={'Admin'} path="/SyncJobLog" name="Sync Job Log" />
            <MenuItem roles={'Admin'} path="/UserUpdates" name="User Updates" />
            <MenuItem roles={'Admin'} path="/Users" name="User Compare" />
            <MenuItem roles={'SuperAdmin'} path="/XrefData" name="Xref Data" />
            <MenuItem roles={'SuperAdmin'} path="/Staging" name="Staging" />
            <MenuItem roles={'SuperAdmin'} path="/Admins" name="Admins" />
            <MenuItem roles={'Admin'} path="/Troubleshooting" name="Troubleshooting" />
            <MenuItem roles={'*'} path="/Logout" name="Log Out" />
        </ul>);
    }

    return (

        <nav className="app-nav kendo-react">
            <div ref={mobileMenuRef} className="mobile-check">&nbsp;</div>
            {isUserAuthenticated(context) &&
                <div className={mobileMenuOpen ? "mobile-menu menu-open" : "mobile-menu"}
                    tabIndex="0"
                    role="button"
                    aria-label="Toggle Navigation"
                    aria-expanded={ariaExpanded ? "true" : "false"}
                    onClick={handleMobileMenuClick}
                    onKeyDown={handleMobileMenuKeyDown}>
                    <span className="mobile-icon"></span>
                </div>}

            {contextMobileView.isMobileView ?
                <Collapse isOpen={mobileMenuOpen}><MenuList /></Collapse>
                :
                <MenuList />
            }
        </nav>

    );
}
